export enum MessagesPostTypes {
  FETCH_MESSAGES_POST_SUCCESS = "FETCH_MESSAGES_POST_SUCCESS",
  FETCH_MESSAGES_POST_FAILURE = "FETCH_MESSAGES_POST_FAILURE",
  FETCH_MESSAGES_POST_REQUEST = "FETCH_MESSAGES_POST_REQUEST"
}